module.exports = __webpack_public_path__ + "img/marker.ef8888d3.png";